const colors = {
    'primary_900': '#FF5D0E',
    'primary_800': '#722324',
    'primary_700': '#8F3C3C',
    'primary_600': '#AA5555',
    'primary_500': '#C66E6E',
    'primary_400': '#E28787',
    'primary_300': '#F8A0A0',
    'primary_200': '#FFB9B9',
    'primary_100': '#FFCFCF',

    'primary_light_800': '#FFD9D9',
    'primary_light_600': '#FFE2E2',
    'primary_light_400': '#FFECEC',
    'primary_light_200': '#FFF5F5',
    'primary_light_000': '#FFFFFF',
};

export default  colors